import FormDialog from '@/components/ui/form-dialog';
import { Customer } from '@/core/entities';
import { useDeleteCustomer } from '@/queries/customers';
import { pushToDataLayer, ContentGroup } from '@/shared/utils/analytics';
import { FunctionComponent, ReactElement } from 'react';

interface DeleteCustomerFormProps {
	open: boolean;
	onClose: () => void;
	customer?: Customer;
	onSubmitted?: () => void;
}

const DeleteCustomerForm: FunctionComponent<DeleteCustomerFormProps> = ({
	open,
	onClose,
	customer,
	onSubmitted,
}): ReactElement => {
	const trackRemoveCustomer = () => {
		pushToDataLayer({
			event: 'customer_removed',
			content_group: ContentGroup.Customers,
			customer_name: customer?.name,
		});
	};

	const { isLoading: isDeleteCustomerFormSubmitting, mutate: onDeleteCustomerFormSubmit } =
		useDeleteCustomer({
			onSuccess: () => {
				onClose();
				onSubmitted?.();
				trackRemoveCustomer();
			},
		});

	return (
		<FormDialog
			open={open}
			onClose={onClose}
			title="Remove customer"
			actions={{
				cancel: {
					label: 'Cancel',
				},
				confirm: {
					label: 'Remove customer',
					isLoading: isDeleteCustomerFormSubmitting,
				},
			}}
			onSubmit={() => customer && onDeleteCustomerFormSubmit(customer.id)}
		>
			{customer &&
				`Are you sure you wish to delete customer ${customer.name}? This action cannot be undone.`}
		</FormDialog>
	);
};

export default DeleteCustomerForm;
